export default function getPeriods() {
  const allPeriods = [];
  const grades = [
    "PRE_K",
    "KINDERGARTEN",
    "FIRST_GRADE",
    "SECOND_GRADE",
    "THIRD_GRADE",
    "FOURTH_GRADE",
    "FIFTH_GRADE",
  ];
  const seasons = ["FALL", "WINTER", "SPRING"];

  for (const grade of grades) {
    for (const season of seasons) {
      allPeriods.push(`${grade}-${season}`);
    }
  }

  return allPeriods;
}
